import React, { useState } from 'react';

const LeadCapture = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    countryCode: '+55',
    whatsapp: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você pode adicionar a lógica para enviar os dados
    console.log('Form data:', formData);
    // Exemplo: enviar para API ou redirecionar
    alert('Cadastro realizado com sucesso! Verifique seu e-mail.');
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const faqQuestions = [
    {
      question: 'O que é isso tudo?',
      answer: 'É um curso completo e gratuito de Design de Sobrancelhas com certificado, criado para transformar sua vida financeira.'
    },
    {
      question: 'Em quanto tempo vou ter resultados com o que vou aprender nesse programa?',
      answer: 'Os resultados podem aparecer rapidamente, dependendo da sua dedicação e prática. Muitos alunos começam a ver resultados já nas primeiras semanas.'
    },
    {
      question: 'Ainda não consegui acessar o curso, o que fazer?',
      answer: 'Verifique sua caixa de entrada e spam. Se não recebeu o e-mail, entre em contato conosco pelo WhatsApp.'
    },
    {
      question: 'Tenho que pagar alguma mensalidade?',
      answer: 'Não! O curso é 100% gratuito. Não há mensalidades ou taxas escondidas.'
    },
    {
      question: 'Por quanto tempo terei acesso ao curso?',
      answer: 'Você terá acesso vitalício ao curso após o cadastro gratuito.'
    }
  ];

  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="lead-capture-page">
      {/* Hero Section com Formulário e Vídeo */}
      <section className="lead-hero">
        <div className="container">
          <h1 className="lead-main-title">
            O ÚNICO CURSO DE DESIGN DE SOBRANCELHAS <span className="highlight-pink">100% GRATUITO</span> E COM <span className="highlight-pink">CERTIFICADO DO MUNDO!</span>
          </h1>
          
          <div className="lead-content-wrapper">
            {/* Formulário à Esquerda */}
            <div className="lead-form-section">
              <h2 className="lead-form-title">Receba o acesso do Curso Gratuito no seu e-mail</h2>
              <p className="lead-form-subtitle">
                Entenda porque tanta gente comum está ganhando dinheiro como Designer em Sobrancelhas.
              </p>
              <iframe 
                src="https://cdn.forms-content-1.sg-form.com/157d6c1d-d503-11f0-9177-626e14d8a398"
                title="Formulário de Cadastro"
                className="lead-form-iframe"
                frameBorder="0"
                scrolling="yes"
                allow="autoplay; encrypted-media"
              />
              {/* <form className="lead-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="text"
                    name="nome"
                    placeholder="Seu Primeiro Nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Seu E-mail"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                
                <div className="form-group form-group-whatsapp">
                  <div className="country-code-selector">
                    <span className="flag-icon">🇧🇷</span>
                    <span className="country-code">+55</span>
                    <span className="dropdown-arrow">▼</span>
                  </div>
                  <input
                    type="tel"
                    name="whatsapp"
                    placeholder="Seu WhatsApp"
                    value={formData.whatsapp}
                    onChange={handleChange}
                    required
                    className="form-input form-input-whatsapp"
                  />
                  <span className="help-icon">?</span>
                </div>
                
                <button type="submit" className="lead-cta-button">
                  CADASTRE-SE GRATUITAMENTE
                </button>
              </form> */}
            </div>
            
            {/* Banner à Direita */}
            <div className="lead-banner-section">
              <div className="banner-container">
                <img 
                  src="/images/henna1.png" 
                  alt="Expert em Henna"
                  className="lead-banner-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção "Pra Quem É o Curso" */}
      <section className="lead-audience">
        <div className="container">
          <h2 className="lead-section-title">TRANSFORME SUA VIDA FINANCEIRA</h2>
          <h3 className="lead-section-subtitle">PRA QUEM É O CURSO?</h3>
          
          <div className="audience-cards-grid">
            <div className="audience-card-item">
              <div className="audience-icon">👍</div>
              <h4>MÉTODO DE SUCESSO</h4>
              <p>Designers de sobrancelhas que não estão satisfeitas com seus resultados e está procurando profissionalizar ainda mais.</p>
            </div>
            
            <div className="audience-card-item">
              <div className="audience-icon">💬</div>
              <h4>AULAS DIDÁTICAS</h4>
              <p>Para quem deseja aprender e crescer constantemente no país, e novas técnicas estão sendo lançadas constantemente! Especialize-se na área e destaque-se!</p>
            </div>
            
            <div className="audience-card-item">
              <div className="audience-icon">💻</div>
              <h4>MERCADO EM ALTA</h4>
              <p>Profissionais da beleza - que já possuem uma profissão e querem poder oferecer novos serviços para suas clientes.</p>
            </div>
            
            <div className="audience-card-item">
              <div className="audience-icon">🏠</div>
              <h4>RENDA EXTRA</h4>
              <p>Todas as pessoas que querem garantir uma nova profissão e faturar até R$3mil reais por mês aumentando a auto estima de mulheres.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção Sobre a Instrutora */}
      <section className="lead-instructor">
        <div className="container">
          <h2 className="lead-instructor-title">
            A PROFISSIONAL <span className="underline-pink">QUE VAI ENSINAR VOCÊ</span>
          </h2>
          
          <div className="lead-instructor-content">
            <p className="lead-instructor-text-bold">
              Letícia Venâncio é especialista em Design de Sobrancelhas e criadora do método Expert em Henna.
            </p>
            <p className="lead-instructor-text">
              Profissional e educadora, transferindo sua experiência em técnicas de design de sobrancelhas com henna.
            </p>
            <p className="lead-instructor-text">
              Faz questão de ressaltar suas origens impulsionada por não aceitar nada menos que o melhor para sua família, iniciou atendendo na poltrona da sala do seu apartamento.
            </p>
            <p className="lead-instructor-text">
              Provando que são as suas decisões e não suas condições que definem o seu futuro.
            </p>
            <p className="lead-instructor-hashtag">#ExpertEmHenna</p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="lead-faq">
        <div className="container">
          <h2 className="lead-faq-title">DÚVIDAS FREQUENTES</h2>
          
          <div className="faq-list">
            {faqQuestions.map((faq, index) => (
              <div key={index} className="faq-item-lead">
                <button
                  className="faq-question-lead"
                  onClick={() => toggleFaq(index)}
                >
                  <span className="faq-arrow">{openFaq === index ? '▼' : '▶'}</span>
                  {faq.question}
                </button>
                {openFaq === index && (
                  <div className="faq-answer-lead">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
          
          <a
            href="https://wa.me/5511999999999"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-cta-button"
          >
            TIRAR DÚVIDAS PELO WHATSAPP
          </a>
        </div>
      </section>

      {/* Footer Legal */}
      <footer className="lead-footer">
        <div className="container">
          <p className="lead-footer-disclaimer">
            De acordo com a lei 12.956/2014 e 13.709/2018, que regulam o uso da internet e o tratamento de dados pessoais no Brasil, autorizo o Curso Expert em Henna a enviar notificações por e-mail ou outros meios e concordo com sua política de privacidade.
          </p>
          <p className="lead-footer-copyright">
            Copyright © 2025 Curso Expert em Henna. Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LeadCapture;
